import { io, Socket } from "socket.io-client";
import { socketNamespace } from "../runtime";

let queueSocket: Socket | null = null;

export function getQueueSocket(): Socket {
  if (!queueSocket) {
    queueSocket = io(socketNamespace("/queue"), {
      autoConnect: false,
      withCredentials: true,
    });
  }
  return queueSocket;
}

export function disconnectQueueSocket(): void {
  if (queueSocket) {
    queueSocket.removeAllListeners();
    queueSocket.disconnect();
    queueSocket = null;
  }
}
